export default {"src":"/_next/static/media/comments.86f0a43c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};